import { getField, updateField } from 'vuex-map-fields'
import api from '@/api/api'
import { Categoria } from '@/models/Categoria'
import Swal from 'sweetalert2'
import { categoriaTransformer } from '@/utils/transformers'

export const SET_STATE = 'SET_STATE'
export const BOOTSTRAP_PROFILE = 'BOOTSTRAP_PROFILE'
export const SUBMIT = 'SUBMIT'
export const RESET_STATE = 'RESET_STATE'

const getDefaultState = () => {
  return {
    estados: [],
    loading: true,
    isEditing: false,
  }
}

const state = getDefaultState()

const getters = {
  getField,
}

const mutations = {
  updateField,
  [RESET_STATE] (state) {
    Object.assign(state, getDefaultState())
  },
  [SET_STATE] (state, payload) {
    Object.assign(state, payload)
  },
}

const actions = {
  async [BOOTSTRAP_PROFILE] ({ dispatch, commit, state }, { id }) {
    commit(RESET_STATE)
    commit('SET_STATE', { loading: true, isEditing: false })
    dispatch('form/BOOTSTRAP_FORM', { model: new Categoria() }, { root: true })
    if (id) {
      commit(SET_STATE, { isEditing: true })
      await api.getEntidade('categoria', id).then(response => {
        response.data.forEach(element => {
          element.tipo = element.tipo.toString()
          element.tipo_pessoa = element.tipo_pessoa.toString()
        })
        commit(SET_STATE, { loading: false })
        dispatch('form/BOOTSTRAP_FORM', { model: new Categoria(categoriaTransformer(response.data[0])) }, { root: true })
      })
    } else {
      commit(SET_STATE, { loading: false, isEditing: false })
    }
  },

  async [SUBMIT] ({ commit, dispatch, state, rootState }, { router, user }) {
    Swal.fire({
      title: 'Cadastrando Categoria!',
      timerProgressBar: true,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading()
      },
      didOpen: () => {
        const form = { ...rootState.form.data };
        (() => {
          return state.isEditing
            ? api.salvarEntidade(form, 'categoria', form.id)
            : api.cadastrarEntidade(form, 'categoria')
        })().then(
          data => {
            Swal.fire({
              title: state.isEditing
                ? 'Categoria atualizada com sucesso!'
                : 'Categoria cadastrada com sucesso!',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500,
            })
            dispatch('categorias/BOOTSTRAP', null, { root: true })
            router.push({
              path: `/${user.get().role}/fluxoCaixaCategorias`,
            })
          },
          error => {
            Swal.fire({
              icon: 'error',
              title: 'Erro',
              text: error.errors ? error.errors : error.message,
            })
          },
        )
      },
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
